<template>
  <!--  getProduct 设备产品 -->
  <div class="mapping">
    <div class="con">
      <div class="tree-left">
        <div class="search">
          <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
        </div>
        <div class="scroll" style="width:100%;height:93%">
          <el-scrollbar style="height:95%;width: 100%;">
            <el-tree :data="leftData" ref="leftTree" :props="defaultProps1" @node-click="leftTreeClick"
              highlight-current :expand-on-click-node="true" node-key="id" :filter-node-method="filterNode"
              :default-expanded-keys="defaultExpanded">
              <span class="custom-tree-node" slot-scope="{node}" style="display: flex;align-items: center;">
                <img src="../../../public/static/image/elTree/1.9.png" style="margin-right: 2px;"
                  v-if="node.data.category == 1" />
                <img src="../../../public/static/image/elTree/group.png" style="margin-right: 2px;" v-else />
                <span style="padding-left: 5px;">{{node.data.uniqueName}} </span>
              </span>
            </el-tree>
          </el-scrollbar>
        </div>
      </div>
      <div class="content">
        <div class="search-input-btn" style="width:100%">
          <el-scrollbar style="height:100%;width: 100%;">
            <div class="my-search-i">

              <div class="input-small mr-20">
                <span>时间类型：</span>
                <el-select v-model="radioSelect" placeholder="请选择">
                  <el-option v-for="item in timestype" :key="item.en" :label="item.ch" :value="item.en"></el-option>
                </el-select>
              </div>
              <div class="input-small myinput">
                <span>选择时间：</span>
                <el-date-picker v-show="radioSelect=='DAY'" v-model="serchTime" type="date" placeholder="选择日期"
                  :picker-options="pickerOptions" value-format="timestamp"></el-date-picker>
                <el-date-picker v-show="radioSelect=='MON'" v-model="serchTime" type="month" placeholder="选择月"
                  :picker-options="pickerOptions" value-format="timestamp"></el-date-picker>
                <el-date-picker v-show="radioSelect=='YEAR'" v-model="serchTime" type="year" placeholder="选择年"
                  :picker-options="pickerOptions" value-format="timestamp"></el-date-picker>
              </div>
              <el-button type="primary" @click="getList" plain class="search-btn">查询</el-button>

              <el-button type="primary" @click="exportList" class="search-btn">导出</el-button>
            </div>
          </el-scrollbar>

        </div>

        <div class="mapping-table">
          <el-table :data="tableData" stripe style="width: 100%" :max-height="heights">
            <template slot="empty">
              <span class="noData">
                <img src="@/assets/noData.png" alt="暂无数据">
                <span class="text">暂无数据</span>
              </span>
            </template>
            <el-table-column label="序号" width="50" align="center">
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="uniqueCode" label="编号"> </el-table-column>

            <el-table-column prop="uniqueName" label="名称" />
            <el-table-column prop="productNum" label="数量" />
            <el-table-column prop="deviceEnergy" label="能耗" />

          </el-table>
        </div>
        <downloadTable ref="downloadTable"></downloadTable>
      </div>
    </div>


    <!-- 新增修改 -->
    <el-dialog width="30%" v-dialogDrag :title="textMap[dialogStatus]" :close-on-click-modal='false'
      :visible.sync="dialogVisible">
      <div class="dialogs">
        <el-form :model="temp" ref="temp" :rules="rules" style="width: 80%;padding-top: 10px;">
          <el-form-item label="产品批号:" prop="batchNumber">
            <el-input v-model="temp.batchNumber"></el-input>
          </el-form-item>
          <!-- <el-form-item label="设备:" prop="deviceId">
            <el-input v-model="temp.deviceId" style="position: absolute;left: 9999px;"></el-input>
            <el-cascader v-model="workshop" :options="leftData" :props="defaultProps" :show-all-levels="false"
              @change="deviceIdFn"></el-cascader>
          </el-form-item> -->
          <el-form-item label="填报类型:" prop="inputType">
            <el-radio v-model="temp.inputType" :label="0">自动</el-radio>
            <el-radio v-model="temp.inputType" :label="1">手动</el-radio>
          </el-form-item>
          <el-form-item label="产品编码:" prop="productCode">
            <el-input v-model="temp.productCode"></el-input>
          </el-form-item>
          <el-form-item label="产品名称:" prop="productName">
            <el-input v-model="temp.productName"></el-input>
          </el-form-item>
          <el-form-item label="产品总数:" prop="productTotal">
            <el-input v-model="temp.productTotal"></el-input>
          </el-form-item>
          <el-form-item label="计量单位:" prop="productUnits">
            <el-input v-model="temp.productUnits"></el-input>
          </el-form-item>
          <el-form-item label="开始时间:" prop="productionStartTime">
            <el-date-picker v-model="temp.productionStartTime" type="date" placeholder="选择日期"
              :picker-options="pickerOptions" value-format="timestamp"> </el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间:" prop="productionEndTime">
            <el-date-picker v-model="temp.productionEndTime" type="date" placeholder="选择日期"
              :picker-options="pickerOptions" value-format="timestamp"> </el-date-picker>
          </el-form-item>
          <el-form-item label="入库总数:" prop="storageTotal">
            <el-input v-model="temp.storageTotal"></el-input>
          </el-form-item>

        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogStatus==='edit'?edit_fn('temp'):add_fn('temp')">保存</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import {getMappingList,recordFindList,recordUpdateValue,recordSave,recordUpdateInfo} from "../../api/capacity";
  import elRadioTree from '@/components/module/tree/elRadioTree.vue'
  import downloadTable from '@/components/module/downloadTable/downloadTable.vue'
  import request from "@/api/http.js";
  export default {
    components: {
      elRadioTree,
      downloadTable
    },
    data () {
      return {
        unitItem: '',
        defaultProps1: {
          children: 'mesTreeChild',
          label: 'uniqueName'
        },
        defaultExpanded: [],
        filterText: '',
        serchTime: '',
        radioSelect: 'DAY',
        timestype: [{
          ch: '日',
          en: 'DAY'
        },

        {
          ch: '月',
          en: 'MON'
        },
        {
          ch: '年',
          en: 'YEAR'
        }
        ],
        defaultProps: {

          children: 'mesTreeChild',
          label: 'uniqueName',
          value: "id",
          checkStrictly: true
        },
        leftData: [{
          uniqueName: '应用数据'
        }],//左边树形结构数据
        heights: Math.round((document.getElementById('app').clientHeight)*0.77),//屏幕高度 - 导航栏高度
        loading: false,
        dialogVisible: false,
        dialogStatus: '',
        textMap: {
          add: "新增填报",
          edit: "编辑填报"
        },
        temp: {
          'capacityName': "",
          'localDevice': "",
          'localDeviceNo': ""
        },
        rules: {
          capacityName: [
            {required: true,message: '请输入映射名称',trigger: 'blur'}
          ],
          recordDay: [
            {required: true,message: '请选择日期',trigger: 'blur'}
          ],
          capacityValue: [
            {required: true,message: '请输入产量',trigger: 'blur'}
          ]
        },
        tableData: [{
          uniqueCode: "001",
          uniqueName: "1号设备",
          productNum: "4",
          deviceEnergy: "5",
        }],
        startDate: "",
        endDate: new Date(),
        options: [],
        nowWorkshop: {},
        workshop: '',
        pickerOptions: {
          disabledDate (time) {
            return time.getTime()>Date.now();
          },

        },
        editType: 0
      };
    },

    mounted () {
      request({url: "/gyMes/findMesTree",method: "get"}).then(res => {
        if(res.code==200) {
          this.leftData=res.data;
        } else {
          res.message? this.$message.error(res.message):this.$message.error('失败')
        }
      })
      this.getSelectList()
      var date=new Date();
      date.setDate(1);
      var cTime=new Date(new Date(date).toLocaleDateString()).getTime();
      this.startDate=cTime

    },
    computed: {
      unitId () {
        return this.$store.unitStore.state.nowUnit
      },
    },
    watch: {
      filterText (val) {
        this.$refs.leftTree.filter(val);
      },
      unitId () {
        this.getSelectList()
      },
    },

    methods: {
      //左边数据结构点击
      leftTreeClick (item) {
        this.unitItem=item;
      },
      //左边树形结构筛选
      filterNode (value,data) {

        if(!value) return true;
        return data.modelName.indexOf(value)!==-1;
      },
      deviceIdFn (v) {
        if(v) {
          this.$set(this.temp,'deviceId',v[v.length-1])
        }
      },
      //获取下拉框列表
      getSelectList () {
        var id=this.unitId.id
        getMappingList({'unitId': id}).then(res => {
          if(res.code==200) {
            this.options=res.data
            if(this.options.length!=0) {
              this.nowWorkshop=res.data[0]
              this.workshop=res.data[0].id

            }

          }
        })
      },
      //获取数据
      getList () {
        if(!this.unitItem) {
          this.$message.error('请选择左边树形')
          return
        }
        if(!this.serchTime) {
          this.$message.error('请选择时间')
          return
        }
        var params={
          id: this.unitItem.id,
          timeType: this.radioSelect,
          times: this.serchTime,
        };
        request({url: "/gyMes/getMesProductNum",method: "get",params}).then(res => {

          if(res.code==200) {
            this.tableData=res.data;

          } else {
            res.message? this.$message.error(res.message):this.$message.error('失败')
          }
        })

      },
      //下拉框
      changeSelect (val) {
        var arr=this.options.filter(item => item.id==val)
        this.nowWorkshop=arr[0]
        this.getList()
      },

      // 添加弹窗
      add_ed (v,l) {

        this.temp={}
        this.temp.capacityName=this.nowWorkshop.capacityName
        this.dialogStatus='add';
        this.dialogVisible=true;
        this.topLevel=v
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });
        // this.temp = { EnergyTypeParentId: v || null};
      },
      // 确认添加
      add_fn (formName) {
        this.$refs[formName].validate(valid => {
          if(valid) {
            var data=this.temp;
            data.deviceId=this.unitItem.id;
            request({url: "/gyMes/saveProducts",method: "put",data}).then(res => {
              if(res.code==200) {
                this.getList();
                this.dialogVisible=false;
                this.$message({showClose: true,message: '添加成功',type: 'success'});
              } else {
                if(res.message) {
                  this.$message.error(res.message);
                } else {
                  this.$message.error('添加失败');
                }
              }
            })

            return
            recordSave(d).then(res => {
              if(res.code==200) {
                this.getList();
                this.dialogVisible=false;
                this.$message({showClose: true,message: '添加成功',type: 'success'});
              } else {
                if(res.message) {
                  this.$message.error(res.message);
                } else {
                  this.$message.error('添加失败');
                }
              }
            })


          } else {
            return false;
          }
        });
      },

      // 确认编辑
      edit_fn () {
        this.$refs['temp'].validate(valid => {
          if(valid) {
            var data=this.temp
            var d={
              "capacityValue": data.capacityValue,
              "id": data.id,
            }
            console.log(d);
            var index=this.tableData.findIndex(item => item.id==data.id)
            if(this.editType==0) { //修正
              recordUpdateValue(d).then(res => {
                if(res.code==200) {
                  //  this.getList();
                  this.tableData[index].capacityValue=res.data.capacityValue
                  this.dialogVisible=false;
                  this.$message({showClose: true,message: '修正成功',type: 'success'});
                } else {
                  res.message? this.$message.error(res.message):this.$message.error('修正失败')

                }
              })
            } else { //编辑
              d.recordDay=typeof data.recordDay=='number'? data.recordDay:data.recordDay.getTime()
              recordUpdateInfo(d).then(res => {
                if(res.code==200) {
                  //  this.tableData[index].capacityValue = res.data.capacityValue
                  this.getList();
                  this.dialogVisible=false;
                  this.$message({showClose: true,message: '编辑成功',type: 'success'});
                } else {
                  res.message? this.$message.error(res.message):this.$message.error('编辑失败')
                }
              })
            }

          } else {
            return false;
          }
        });
      },
      //编辑弹窗 0 为自动填报，1为手工填报
      edit_ed (v,type) {
        if(type==0) {
          this.textMap.edit='修正自动填报'
        } else {
          this.textMap.edit='编辑手工填报'
        }
        this.editType=type

        this.dialogStatus='edit';
        this.temp=Object.assign({},v);
        this.temp.capacityName=this.nowWorkshop.capacityName
        this.dialogVisible=true;
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });




      },
      //下载表格excel
      exportList () {
        let time=new Date();
        let year=time.getFullYear();
        let month=time.getMonth()+1;
        let day=time.getDate();

        const tHeader=[];
        this.$refs.downloadTable.export2Excel(tHeader,this.tableData,year+"-"+month+"-"+day+'-产量管理','.mapping-table')
      },



    },
    filters: {
      // 转换时间戳
      "date_format": function(value) { //value就是插值的数据
        if(!value) {
          return ""
        }
        let date=new Date(value);
        let Y=date.getFullYear()+'-';
        let M=(date.getMonth()+1<10? '0'+(date.getMonth()+1):date.getMonth()+1)+'-';
        let D=(date.getDate()<10? '0'+(date.getDate()):date.getDate())+' ';
        let strDate=Y+M+D;
        return strDate
      },
    }
  };
</script>

<style lang="scss" scoped>
  .con {
    width: 100%;
    height: 100%;
    display: flex;
    box-sizing: border-box;
    overflow: hidden;

    .con-title {
      display: flex;
      align-items: center;
      font-size: 18px;
      margin-left: 10px;
      margin-top: 20px;

      img {
        width: 28px;
        height: 28px;
        margin-right: 10px;
      }
    }

    .tree-left {
      width: 3rem;
      height: 100%;
      padding: 20px 12px 12px 12px;
      box-sizing: border-box;
      background-color: #fff;
      margin-right: 8px;

      .btns {
        display: flex;
        // justify-content: space-evenly;
        margin-bottom: 8px;

        button {
          margin-right: 12px;
        }

        .el-button--mini {
          padding: 7px 10px !important;
        }

        .el-button+.el-button {
          margin-left: 0px;
        }
      }

      .search {
        display: flex;
        justify-content: center;
        margin-bottom: 12px;
      }

    }

    .content {

      .content-title {
        margin-left: 20px;
        margin-top: 20px;
        font-size: 16px;
        color: #999;
      }

      .mytable {
        width: 86.5%;
        margin: 20px 20px 0px 20px;


      }

      .conten-btns {
        margin-top: 200px;

        // button {
        //    margin-bottom: 20px;
        // }
        div {
          width: 0.88rem;
          height: 32px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 14px;
          border-radius: 2px;
          background-color: #409EFF;
          color: #fff;
          margin-bottom: 40px;
          cursor: pointer;

          img {
            width: 0.2rem;
            height: 0.2rem;
            margin-left: 0.1rem;
          }
        }

      }
    }

    .tree-right {
      width: 3rem;
      height: 100%;
      background-color: #fff;
      padding: 20px 12px 12px 20px;
      box-sizing: border-box;
    }
  }

  .mapping {
    width: 100%;
    height: 100%;
    background-color: #ebf4ff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px;

    .content {
      width: calc(100% - 3rem);
      background-color: #fff;
      border-right: 1px solid #e6e6e6;
      box-sizing: border-box;
      padding: 10px;

      .mapping-table {
        margin-top: 20px;

        /deep/.el-table th.is-leaf {
          border-bottom: 0px;
        }

        .buttoned_box {
          display: flex;
          justify-content: center;
          align-items: center;

          .line {
            display: inline-block;
            width: 1px;
            height: 20px;
            background-color: #E6E6E6;
            margin: 0px 20px;
          }

          .buttoned {
            cursor: pointer;
          }

          /deep/.el-button span {
            font-size: 15px;
            font-weight: 400;
          }
        }
      }

    }

    .dialogs {
      /deep/.el-input__inner {
        width: 250px;
      }
    }

    /deep/.el-dialog__header {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #f5f5f5;

      span {
        color: #67A3ED;
        font-size: 16px;
      }

      .el-icon-close {
        font-size: 22px !important;
      }

    }

    /deep/.el-dialog__footer {
      margin-top: 20px;
      text-align: right !important;
      border-top: 1px solid #f5f5f5;

      button {
        padding: 8px 17px;
      }
    }

    /deep/.el_Tree_Body {
      height: 99.5%;
    }

    .demo-temp {
      display: flex;
      flex-wrap: wrap;
    }

    /deep/.el-form-item {
      display: flex;
      margin-left: 20px;
    }

    /deep/.el-form-item__label {
      white-space: nowrap;
      width: 85px;
    }

    /deep/.el-dialog__body {
      padding: 20px 0px 0px 20px !important;
    }

  }
</style>